import React, { useState, useEffect } from "react";

export function useScrolling() {
    const [isScrolling, setIsScrolling] = useState(false);

    function handleWindowScrolling() {
        const top = typeof window.scrollY === "undefined" ? window.pageYOffset : window.scrollY;

        setIsScrolling(top !== 0);
    }

    useEffect(() => {
        window.addEventListener("scroll", handleWindowScrolling);
        handleWindowScrolling();

        return () => window.removeEventListener("scroll", handleWindowScrolling);
    }, []);

    return isScrolling;
}

export function withScrolling(Component) {
    function ScrollingWrap(props) {
        const scrolling = useScrolling();

        return <Component {...props} scrolling={scrolling} />;
    }
    ScrollingWrap.displayName = `withScrolling(${Component.displayName})`;

    return ScrollingWrap;
}
